import axios from 'axios';
import UserUtils from '../component/utils/UserUtils'

const MESSAGE_API_BASE_URL = process.env.REACT_APP_API_URL + '/api/messages';

class MessageService {
    
    fetchSearchMessages(criterias) {
        return axios.post(MESSAGE_API_BASE_URL+'/search', criterias);
    }

    sendMessage(message){
        return axios.post(MESSAGE_API_BASE_URL+'/', message);
    }

    updateStatus(numMessage, infosStatus){
        return axios.patch(MESSAGE_API_BASE_URL+'/'+numMessage, infosStatus);
    }

    fetchReceivers(customerCode) {
        let searchReceivers = {
            caseCustomerCode : customerCode,
            ima : UserUtils.getUser().ima
         }
        return axios.post(MESSAGE_API_BASE_URL+'/receivers',searchReceivers);
    }

    fetchUsersTreatedBy() {
        let criteria = { 
            codesClient : UserUtils.getUser().code_client
        }
        return axios.post(MESSAGE_API_BASE_URL+'/treatedBy',criteria);
    }

    accessLock(idCase, idMsg) {
        let user = UserUtils.getUser();
        let accessLock = {
            caseId: idCase,
            traitePar: user.name,
            loginTraitePar: user.email,
            idMsg: idMsg,
            ima: user.ima
        }
        return axios.post(MESSAGE_API_BASE_URL+'/accesslock', accessLock);
    }

    contactUs(infosContactUs){
        return axios.post(MESSAGE_API_BASE_URL+'/contactUs', infosContactUs);
    }

}

export default new MessageService();